import { render, staticRenderFns } from "./BrokenAppointments.vue?vue&type=template&id=0069deeb&scoped=true"
import script from "./BrokenAppointments.vue?vue&type=script&lang=js"
export * from "./BrokenAppointments.vue?vue&type=script&lang=js"
import style0 from "./BrokenAppointments.scss?vue&type=style&index=0&id=0069deeb&prod&lang=scss&scoped=true&external"
import style1 from "../Followups/broken-appointments-page.scss?vue&type=style&index=1&id=0069deeb&prod&lang=scss&scoped=true&external"
import style2 from "./BrokenAppointments.vue?vue&type=style&index=2&id=0069deeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069deeb",
  null
  
)

export default component.exports